(function(){
    angular
        .module('appback')
        .filter('uniqueanaliticas', unique);

        unique.$inject = ['$sce'];
        function unique($sce){
            return function (input) {
	            var seen = { objectNames: [] };
			    return input.filter(function(obj){
			      return !seen.objectNames.includes(obj.analitica.id) 
			        && seen.objectNames.push(obj.analitica.id)
			    })
	        };
      }
})();